// src/data/dial-codes.js
// Mapa nombre de entidad DXCC → prefijo telefónico internacional.
// Las claves coinciden exactamente con DXCC_LIST[].name en src/data/dxcc.js.

const DIAL_CODES = {
    // América del Sur
    'Argentina':                '+54',
    'Bolivia':                  '+591',
    'Brazil':                   '+55',
    'Chile':                    '+56',
    'Colombia':                 '+57',
    'Ecuador':                  '+593',
    'Paraguay':                 '+595',
    'Peru':                     '+51',
    'Uruguay':                  '+598',
    'Venezuela':                '+58',
    'French Guiana':            '+594',
    // América del Norte / Central / Caribe
    'United States of America': '+1',
    'Canada':                   '+1',
    'Mexico':                   '+52',
    'Cuba':                     '+53',
    'Dominican Republic':       '+1',
    'Costa Rica':               '+506',
    'Guatemala':                '+502',
    'Honduras':                 '+504',
    'Nicaragua':                '+505',
    'El Salvador':              '+503',
    'Panama':                   '+507',
    // Europa
    'Spain':                    '+34',
    'Portugal':                 '+351',
    'France':                   '+33',
    'Fed. Rep. of Germany':     '+49',
    'Italy':                    '+39',
    'England':                  '+44',
    'Netherlands':              '+31',
    'Belgium':                  '+32',
    'Switzerland':              '+41',
    'Austria':                  '+43',
    'Sweden':                   '+46',
    'Norway':                   '+47',
    'Denmark':                  '+45',
    'Finland':                  '+358',
    'Poland':                   '+48',
    'Czech Republic':           '+420',
    'Hungary':                  '+36',
    'Romania':                  '+40',
    'Greece':                   '+30',
    'European Russia':          '+7',
    'Asiatic Russia':           '+7',
    'Ukraine':                  '+380',
    // Asia
    'Japan':                    '+81',
    'China':                    '+86',
    'India':                    '+91',
    'Republic of Korea':        '+82',
    'Indonesia':                '+62',
    'Philippines':              '+63',
    'Thailand':                 '+66',
    'West Malaysia':            '+60',
    'East Malaysia':            '+60',
    'Singapore':                '+65',
    // Oceanía
    'Australia':                '+61',
    'New Zealand':              '+64',
    // África
    'South Africa':             '+27',
};

/**
 * Devuelve el prefijo telefónico para el nombre de entidad DXCC dado.
 * @param {string} paisName — exactamente entidad.name de DXCC_LIST
 * @returns {string|null}
 */
export function getDialCode(paisName) {
    return DIAL_CODES[paisName] ?? null;
}

/**
 * Rellena un input con el prefijo del país, solo si está vacío o
 * contiene únicamente un prefijo auto-generado previo (+dígitos).
 * @param {HTMLInputElement|null} inputEl
 * @param {string} paisName
 */
export function aplicarPrefijoCampoTelefono(inputEl, paisName) {
    if (!inputEl || !paisName) return;
    const codigo = getDialCode(paisName);
    if (!codigo) return;
    const val = inputEl.value.trim();
    if (val === '' || /^\+\d+\s*$/.test(val)) {
        inputEl.value = codigo + ' ';
    }
}
